import {
  mapMarkerIcon,
  userIcon,
  globeIcon,
  graphIcon,
  fileReportIcon,
  jsIcon,
  homeIcon,
  checkOutlineIcon,
  envelopIcon,
  lockIcon,
  exclamationCircleIcon,
  copyIcon,
} from '@progress/kendo-svg-icons';

export class Icons {
  static mapMarkerIcon = mapMarkerIcon;
  static userIcon = userIcon;
  static globeIcon = globeIcon;
  static graphIcon = graphIcon;
  static fileReportIcon = fileReportIcon;
  static jsIcon = jsIcon;
  static homeIcon = homeIcon;
  static checkOutlineIcon = checkOutlineIcon;
  static exclamationCircleIcon = exclamationCircleIcon;
  static envelopIcon = envelopIcon;
  static lockIcon = lockIcon;
  static copyIcon = copyIcon;
}
